const chevron_down = "data:image/svg+xml,%3csvg%20width='12'%20height='8'%20viewBox='0%200%2012%208'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M11.0048%200.528625L11.9476%201.47143L6.14287%207.27617L0.338135%201.47143L1.28094%200.528625L6.14287%205.39056L11.0048%200.528625Z'/%3e%3c/svg%3e";
export {
  chevron_down as default
};
//# sourceMappingURL=chevron_down.svg.es.js.map
